<div class="editable-title-container" [ngClass]="{'is-editing': isEditing, 'compact': compact}">
	<div
		*ngIf="!isEditing"
		class="title-display group flex items-center gap-2 cursor-pointer min-w-0"
		[style.justify-content]="pos"
		(click)="startEditing()">
		<div class="title-text shrink min-w-0 self-center" [style.color]="customColor || null">
			<green-middle-truncate class="block w-full" [tailLength]="maxLength" [text]="value || placeholder" />
		</div>

		<button
			*ngIf="!readonly"
			mat-icon-button
			[matTooltip]="'BUTTONS.EDIT' | translate"
			(click)="$event.stopPropagation(); startEditing()"
			class="edit-icon shrink-0 self-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-primary">
			<mat-icon
				fontSet="material-icons-outlined"
				style="font-size: 24px; width: 24px; height: 24px; line-height: 1;">
				edit
			</mat-icon>
		</button>
	</div>

	<div *ngIf="isEditing" class="title-edit flex items-center w-full pulse-border">
		<input
			#titleInput
			class="title-input flex-1"
			[(ngModel)]="tempValue"
			[placeholder]="placeholder"
			(keyup.enter)="save()"
			(keyup.escape)="cancel()" />
		<div class="edit-actions flex justify-end gap-1 px-2 py-1">
			<button
				mat-icon-button
				color="warn"
				(click)="cancel()"
				class="action-btn cancel-btn">
				<mat-icon>close</mat-icon>
			</button>
			<button
				mat-icon-button
				color="primary"
				(click)="save()"
				class="action-btn save-btn"
				[disabled]="(required && !tempValue.trim()) || tempValue.trim() === value">
				<mat-icon>check</mat-icon>
			</button>
		</div>
	</div>
</div>
